import React from 'react'

import {t} from '@lib/helpers'

const ImageSlideshow = ({src, duration = '20s', direction = 'left'}) => {
  return (
    <div className='Landing__slideshow'>
      <div
        className='Landing__slideshow__track'
        style={{
          animationDuration: duration,
          animationDirection: direction === 'right' ? 'reverse' : 'normal',
        }}
      >
        {[...Array(3)].map((_, i) => (
          <div className='Landing__slideshow__strip' key={i}>
            <img src={src} alt='Client logos' loading='lazy' />
          </div>
        ))}
      </div>
    </div>
  )
}

const Trusted = () => {
  const stats = t('pages.index.landing.trusted.stats') || []

  return (
    <section className='Landing__trusted'>
      <div className='container'>
        <span className='Landing__trusted__label'>
          {t('pages.index.landing.trusted.label')}
        </span>
        <h2 className='Landing__trusted__h2'>
          {t('pages.index.landing.trusted.h2')}
        </h2>
      </div>
      <ImageSlideshow
        src='/images/our-trusting-client-logo-1.webp'
        duration='25s'
        direction='left'
      />
      <ImageSlideshow
        src='/images/our-trusting-client-logo-2.webp'
        duration='20s'
        direction='right'
      />
      <div className='container'>
        <div className='Landing__trusted__stats'>
          {Array.isArray(stats) &&
            stats.map((stat) => (
              <div className='Landing__trusted__stats__item' key={stat.number}>
                <span className='Landing__trusted__stats__number'>
                  {stat.number}
                </span>
                <span className='Landing__trusted__stats__title'>
                  {stat.title}
                </span>
                <span className='Landing__trusted__stats__desc'>
                  {stat.description}
                </span>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Trusted
